import { render, staticRenderFns } from "./StockAntsAdminDashboard.vue?vue&type=template&id=1f1d7dd2&scoped=true&"
import script from "./StockAntsAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./StockAntsAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StockAntsAdminDashboard.vue?vue&type=style&index=0&id=1f1d7dd2&lang=scss&scoped=true&"
import style1 from "./StockAntsAdminDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d7dd2",
  null
  
)

export default component.exports